import React, { useContext, useEffect, useRef, useState } from "react";
import "./SuccessComponent.css";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { set_image_upload_status } from "../store/image_upload";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import FileContext from "../context/Context";
import CloseIcon from '@mui/icons-material/Close';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Processing = () => {
	const [emailSent, setEmailSent] = useState(false);
	const [isSubmittingRating, setIsSubmittingRating] = useState(false);
	const [isPopupOpen, setPopupOpen] = useState(false);
	const [ratingSucceeded, setRatingSucceded] = useState(false);
	const dispatch = useDispatch();
	const [rating, setRating] = useState(5);
	const navigate = useNavigate();
	const { auditID } = useSelector((state) => state.imagesStore);
	const { image_upload_status } = useSelector(state => state.imageUploadStore);
	const [imageUploadStatus, setImageUploadStatus] = useState(image_upload_status);
	const { capturedInspectionImages, carView, odometerVideo } = useContext(FileContext);
	const [qualityCheck, setQualityCheck] = useState(false);
	const [reportGeneration, setReportGeneration] = useState(false);
	const [reportGenerated, setReportGenerated] = useState(false); // New state for report completion
	
	// Retake Images State and Refs
	const [isRetakePopupOpen, setIsRetakePopupOpen] = useState(true);
	const [retakeImages, setRetakeImages] = useState([]);
	const fileInputRef = useRef(null);
	const selectedPartRef = useRef(null);
	
	const check = `${process.env.PUBLIC_URL}/custom-icons/timer.png`;
	const timer = `${process.env.PUBLIC_URL}/inspection-images/check-icon.png`;
	const star = `${process.env.PUBLIC_URL}/inspection-images/star.png`;
	const step1_pink = `${process.env.PUBLIC_URL}/custom-icons/step1-pink.svg`;
	const step2_grey = `${process.env.PUBLIC_URL}/custom-icons/step2-grey.svg`;
	const step3_grey = `${process.env.PUBLIC_URL}/custom-icons/step3-grey.png`;
	const step2_pink = `${process.env.PUBLIC_URL}/custom-icons/step2-pink.png`;
	const step3_pink = `${process.env.PUBLIC_URL}/custom-icons/step3-pink.png`;
	const close = `${process.env.PUBLIC_URL}/custom-icons/close.png`;
	const success = `${process.env.PUBLIC_URL}/inspection-images/success-background.png`;
	const starEmpty = `${process.env.PUBLIC_URL}/inspection-images/image.png`;
	const starFilled = `${process.env.PUBLIC_URL}/inspection-images/star-filled.png`;
	const cameraIcon = `${process.env.PUBLIC_URL}/custom-icons/camera-icon.png`;
	
	const storedConfig = localStorage.getItem("inspectionConfiguration");
	const inspectionConfig = storedConfig
		? JSON.parse(storedConfig).inspection_config
		: { selectedItems: [], selectedMode: "photo", selectedCount: 10 };

	// Define mandatory base images (8 sides of the car)
	const mandatoryImages = [];

	// Define additional images based on selected items	
	const requiredImages = {
		"Front Side": ["front_side"],
		"Front Left Side": ["front_left_side"],
		"Left Side": ["left_side"],
		"Back Left Side": ["back_left_side"],
		"Back Side": ["back_side"],
		"Back Right Side": ["back_right_side"],
		"Right Side": ["right_side"],
		"Front Right Side": ["front_right_side"],
		"Windshield": ["inner_windshield", "outer_windshield"],
		"Tyres": ["front_left_tyre", "front_right_tyre", "back_left_tyre", "back_right_tyre"],
		"Odometer": ["odometer"],
		"Registration number": ["registrationNo"],
		"Chassis": ["chassis"],
		"RC": ["RC"],
		"Video of RPM": ["video_rpm"],
		"Selfie with the car": ["selfie"]
	};

	// Retake Images Functions
	const handleOpenRetakePopup = () => setIsRetakePopupOpen(true);
	
	// const handleCloseRetakePopup = () => {
	// 	setIsRetakePopupOpen(false);
	// 	// Modal close hone par report generation start karein
	// 	startReportGeneration();
	// };
	const handleCloseRetakePopup = async () => {
	setIsRetakePopupOpen(false);

	if (retakeImages.length > 0) {
		console.log("Setting NO for pending retake images:", retakeImages);
		
		for (const item of retakeImages) {
			try {
				// const dbImageName = item.file_name.replace(/^[0-9A-Z]+_/, '');
				
				await axios.post("/create_audit/update_token", {
					audit: auditID,
					retake_status: "NO",
					image_name: item.file_name
				});
				console.log(`✅ ${item.file_name} = NO (user skipped)`);
			} catch (err) {
				console.error(`❌ Failed to update ${item.file_name}:`, err);
			}
		}
	}
	
	// send email after closing modal
	if (auditID && !emailSent) {
		console.log("Sending completion email after retake process...");
		try {
			await sendCompletionEmail(auditID);
			console.log("✅ Email sent successfully");
			setEmailSent(true);
		} catch (error) {
			console.error("❌ Error sending email:", error);
			// toast.warning('Email notification failed, but continuing process', {
			// 	position: "bottom-right",
			// 	autoClose: 3000,
			// });
		}
	}
	
	// start report generation after closing modal
	startReportGeneration();
};

const closeTab = () => {
	console.log('close');
	navigate('/userType');
};

	const startReportGeneration = async () => {
		if (!reportGeneration) {
			console.log("Starting report generation...");
			setReportGeneration(true);
			
			// Show toast notification
			// toast.info('Report generation started. This may take a few moments...', {
			// 	position: "bottom-right",
			// 	autoClose: 5000,
			// });
			
			try {
				// Call your report generation API here
				// await simulateReportGeneration();
				
				// For now, simulate a delay
				setTimeout(() => {
					setReportGenerated(true);
					// toast.success('Report generated successfully!', {
					// 	position: "bottom-right",
					// 	autoClose: 3000,
					// });
					console.log("Report generation completed");
				}, 5000);
				
			} catch (error) {
				console.error('Error in report generation:', error);
				toast.error('Failed to generate report', {
					position: "bottom-right",
					autoClose: 3000,
				});
			}
		}
	};

	// Actual report generation API call
	const generateReportAPI = async () => {
		try {
			const response = await axios.post("/create_audit/generate-report", {
				audit: auditID,
			});
			
			if (response.status === 200 || response.status === 201) {
				console.log('Report generated successfully:', response.data);
				setReportGenerated(true);
				return true;
			}
			return false;
		} catch (error) {
			console.error('Error generating report:', error);
			throw error;
		}
	};

	const getRetakeImages = auditID => {
		const retakeList = [];
		console.log('Checking retake images for audit:', auditID);

		for (let i = 0; i < localStorage.length; i++) {
			const key = localStorage.key(i);

			// Only process stencil_result entries for the current audit
			if (key.startsWith(`stencil_result_${auditID}`)) {
				try {
					const value = JSON.parse(localStorage.getItem(key));
					if (value?.result === 'No Match') {
						// Extract readable image name
						const partName = key.split(`${auditID}_`)[1]?.replace(/_/g, ' ');
						retakeList.push({
							key,
							part: partName || key,
							file_name: value.file_name
						});
					}
				} catch (err) {
					console.error('Error parsing localStorage data:', key, err);
				}
			}
		}

		return retakeList;
	};

	useEffect(() => {
		if (auditID) {
			console.log('Fetching retake images...');
			const list = getRetakeImages(auditID);
			console.log('Retake images found:', list);
			setRetakeImages(list);
			
			// Agar koi retake image nahi hai, to modal automatically close karein
			if (list.length === 0) {
				console.log('No retake images found. Starting report generation...');
				setIsRetakePopupOpen(false);
				startReportGeneration(); // Retake images nahi hain to directly report generation start karein
			}
		}
	}, [auditID]);

	const handleCameraClick = item => {
		selectedPartRef.current = item;
		if (fileInputRef.current) {
			fileInputRef.current.value = ''; // reset
			fileInputRef.current.click();
		} else {
			console.error('File input ref not found!');
		}
	};

	const handleImageCapture = async event => {
		const file = event.target.files[0];
		if (!file) return;

		const reader = new FileReader();
		reader.onloadend = async () => {
			const base64String = reader.result.split(',')[1];
			const { file_name, key } = selectedPartRef.current;
			console.log('Retake upload for:', file_name, key);

			try {
				const response = await axios.post('/process_data/upload-file', {
					blobName: `Insurance_Inspection/auditImages/${file_name}`,
					fileContent: base64String,
					contentType: 'image/jpeg'
				});

				if (response.status === 200) {
					console.log(`✅ Retake uploaded for: ${file_name}`);

					//  const dbImageName = file_name.replace(/^[0-9A-Z]+_/, '');
                await axios.post("/create_audit/update_token", {
                    audit: auditID,
                    retake_status: "YES",
                    image_name: file_name
                }).catch(err => {
                    console.error("Database update error:", err);
                });

					// Update localStorage
					const oldData = JSON.parse(localStorage.getItem(key));
					localStorage.setItem(
						key,
						JSON.stringify({ ...oldData, result: 'Retaken' })
					);

					// Remove from retake list
					setRetakeImages(prev => prev.filter(img => img.key !== key));
					
					// Agar saari retake images ho gayi hain, to modal close karein
					const updatedList = retakeImages.filter(img => img.key !== key);
					if (updatedList.length === 0) {
						setTimeout(() => {
							handleCloseRetakePopup();
						}, 1000);
					}
				}
			} catch (error) {
				console.error('Upload error:', error);
			}
		};

		reader.readAsDataURL(file);
	};

	const sendCompletionEmail = async (auditId) => {
		try {
			console.log("Sending completion email for audit:", auditId);
			
			// Pehle check karein Hyundai audit hai ya nahi
			const checkResponse = await axios.post("/rating/check-hyundai-audit", {
				auditId: auditId
			}).catch(err => {
				console.warn("Hyundai check failed, proceeding with regular email:", err);
				return { data: { isHyundai: false } };
			});

			const isHyundai = checkResponse?.data?.isHyundai || false;
			console.log("Is Hyundai audit?", isHyundai);

			// Email send karein (with timeout to prevent hanging)
			const emailPromise = axios.post("/rating/send-upload-complete-email", {
				audit_id: auditId,
				status: "upload_complete",
				message: isHyundai
					? "Audit completed successfully in photo mode (HYUNDAI)"
					: "Audit completed successfully in photo mode"
			});

			// Timeout set karein taaki email API hang na kare
			const timeoutPromise = new Promise((_, reject) => 
				setTimeout(() => reject(new Error('Email timeout')), 10000)
			);

			const emailResponse = await Promise.race([emailPromise, timeoutPromise]);
			
			if (emailResponse.status === 200 || emailResponse.status === 201) {
				console.log('✅ Email notification sent successfully');
				setEmailSent(true);
				return true;
			}
		} catch (error) {
			console.error("❌ Error sending completion email:", error.message);
			// Email fail hone par bhi process continue karein
			toast.warning('Email notification failed, but process continues', {
				position: "bottom-right",
				autoClose: 3000,
			});
			return false;
		}
	};

	useEffect(() => {
		if (!image_upload_status) return;

		console.log("Original image_upload_status:", image_upload_status);

		// Ensure all mandatory images + selected item images are included
		const filteredStatus = Object.keys(image_upload_status).reduce((acc, key) => {
			if (
				mandatoryImages.includes(key) || inspectionConfig &&
				inspectionConfig.selectedItems?.some(item => requiredImages[item]?.includes(key))
			) {
				acc[key] = image_upload_status[key];
			}
			return acc;
		}, {});

		setImageUploadStatus(filteredStatus);
	}, [image_upload_status]);

	// Auto-trigger rating popup when both quality check and report generation are complete
	useEffect(() => {
		if (qualityCheck && reportGenerated && !isPopupOpen && !ratingSucceeded) {
			console.log("Conditions met for rating popup:");
			console.log("- Quality check:", qualityCheck);
			console.log("- Report generated:", reportGenerated);
			console.log("- Popup not open:", !isPopupOpen);
			console.log("- Rating not succeeded:", !ratingSucceeded);
			
			// Thoda delay dekar rating popup show karein
			setTimeout(() => {
				console.log("Opening rating popup...");
				setPopupOpen(true);
			}, 2000);
		}
	}, [qualityCheck, reportGenerated, isPopupOpen, ratingSucceeded]);

	useEffect(() => {
		if (imageUploadStatus) {
			console.log("Rechecking audit images...");
			recheckAuditImages();
		}
	}, [imageUploadStatus]);

	const azure_image_file_name = (audit_id, image_name, file_name) => {
		return `${audit_id}_${image_name}_${file_name}`
	};

	const axiosInstance = axios.create({
		timeout: 30000,
	});
	
	const upload_images_data_db = async (formData, image_name, maxRetries = 3) => {
		let attempt = 0;

		const tryUpload = async () => {
			try {
				const response = await axiosInstance.post(
					"/process_data/upload_process_store_individually",
					formData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
						},
					}
				);

				if (response.status === 200) {
					const res = {
						image_name: image_name,
						status: 1,
						type: "sql_upload_status",
					};
					dispatch(set_image_upload_status(res));
					console.log("Successful sql upload", response.data);
					return res;
				}
			} catch (error) {
				attempt++;
				if (attempt < maxRetries && (error.code === "ECONNABORTED" || (error.response && error.response.status >= 500))) {
					console.log(`Attempt ${attempt} failed. Retrying in ${Math.pow(2, attempt)} seconds...`);
					await new Promise((resolve) => setTimeout(resolve, Math.pow(2, attempt) * 1000));
					return tryUpload();
				} else {
					console.error("Max retries reached or non-retryable error:", error);
					return false;
				}
			}
		};

		return tryUpload();
	};

	const uploadCachedImageToS3 = async (fileName, image_name) => {
		try {
			const cache = await caches.open('image-cache');
			const keys = await cache.keys();

			// Filter cached keys matching the fileName
			const matchingKeys = keys.filter(request =>
				request.url.includes(`${fileName}`)
			);

			if (matchingKeys.length === 0) {
				console.log('No matching cached image found');
				return;
			}

			const cachedResponse = await cache.match(matchingKeys[0]);
			if (!cachedResponse) {
				throw new Error(`No cached image found with the key: ${fileName}`);
			}

			// Convert cached response to Base64
			const imageBuffer = await cachedResponse.arrayBuffer();
			const base64String = btoa(
				new Uint8Array(imageBuffer).reduce(
					(data, byte) => data + String.fromCharCode(byte),
					''
				)
			);

			// Upload via backend API to S3
			const response = await axios.post('/process_data/upload-file', {
				blobName: `Insurance_Inspection/auditImages/${fileName}`,
				fileContent: base64String,
				contentType: 'image/png'
			});

			if (response.status === 200) {
				// ✅ Dispatch success status
				const res = {
					image_name,
					status: 1,
					type: 's3_img_upload_status'
				};
				dispatch(set_image_upload_status(res));

				console.log(
					'✅ Cached image uploaded successfully to S3:',
					response.data.url
				);
			} else {
				console.error('❌ Upload failed with status:', response.status);
			}
		} catch (error) {
			console.error(
				'Error retrieving or uploading cached image:',
				error.message
			);
		}
	};
	
	const handleButtonClick = () => {
		setPopupOpen(true);
	};

	const handleClosePopup = () => {
		setPopupOpen(false);
	};

	const handleStarClick = (star) => {
		setRating(star);
	};

	const handleSubmit = async () => {
		if (rating === 0) return;

		setIsSubmittingRating(true);
		console.log("Rating being sent:", rating);
		try {
			// API call to save rating
			const response = await axios.post("/rating/save-rating", {
				audit: auditID,
				Rating: rating,
			});
			console.log(`Saving rating: ${rating} stars for audit ID: ${auditID}`);
			if (response.status === 200 || response.status === 201) {
				console.log('Rating saved successfully:', response.data);
				setRatingSucceded(true);
				toast.success(`${rating} star rating saved successfully!`, {
					position: "bottom-right",
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
				});
			}
		} catch (error) {
			console.error('Error saving rating:', error);
			toast.error('Failed to save rating. Please try again.', {
				position: "bottom-right",
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
			});
		} finally {
			setIsSubmittingRating(false);
		}
	};

	const uploadVideoToServer = async (fileName, videoBlob) => {
		try {
			const formData = new FormData();
			formData.append('file', videoBlob, fileName);
			formData.append('blobName', `Insurance_Inspection/auditVideos/${fileName}`);

			await axios.post('/process_data/upload_video_to_s3', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				},
			});

			console.log('Video Upload successful');
		} catch (error) {
			console.error('Error uploading video:', error);
		}
	};

	const handleRetry = async () => {
		let lastKey = null;
		const retryPromises = [];
		console.log("300-image_upload_status", image_upload_status);

		// Iterate over the keys using for...in
		for (let image_name_key in image_upload_status) {
			const imageDetail = capturedInspectionImages.find(
				(image) => image.name === image_name_key
			);

			if (!imageDetail) {
				console.warn(`No matching image found for ${image_name_key}, skipping...`);
				continue;
			}
			if (
				image_upload_status[image_name_key].s3_img_upload_status === 0 ||
				image_upload_status[image_name_key].sql_upload_status === 0
			) {
				const fileName = azure_image_file_name(
					auditID,
					imageDetail.name,
					imageDetail.file.name
				);

				if (auditID) {
					const retryTask = (async () => {
						const cache = await caches.open("image-cache");
						const keys = await cache.keys();
						const matchingKeys = keys.filter((request) =>
							request.url.includes(`${fileName}-meta`)
						);

						if (matchingKeys.length === 0) {
							console.log("No matching cached image found");
							return;
						}

						const cachedResponse = await cache.match(matchingKeys[0]);
						if (cachedResponse) {
							const cachedData = await cachedResponse.json();
							const formData = new FormData();

							if (image_upload_status[image_name_key].s3_img_upload_status === 0) {
								await uploadCachedImageToS3(fileName, cachedData.name);
							}

							if (image_upload_status[image_name_key].sql_upload_status === 0) {
								formData.append("clickedTime", cachedData.clicked_time);
								formData.append("name", cachedData.name);
								formData.append("id", cachedData.type);
								formData.append("auditID", cachedData.audit_id);
								formData.append("latitude", cachedData.latitude);
								formData.append("longitude", cachedData.longitude);
								formData.append("azure_image_name", fileName);
								await upload_images_data_db(formData, cachedData.name);
							}
						} else {
							console.log("No cached data found");
						}
					})();

					retryPromises.push(retryTask);
				}
			}

			lastKey = image_name_key;
		}

		await Promise.all(retryPromises);
		return 1;
	};

	const hasRunRef = useRef(false);
	useEffect(() => {
		const funcCall = async () => {
			console.log("Initial funcCall running...");
			const odometer_video_file_name = `${auditID}_rpm_meter_video.mp4`;
			if (odometerVideo?.length > 0) {
				console.log("Uploading odometer video...");
				await uploadVideoToServer(odometer_video_file_name, odometerVideo[0]);
			}
			console.log("Starting retry process...");
			await handleRetry();
			console.log("Retry process completed");
		};

		if (!hasRunRef.current) {
			funcCall();
			hasRunRef.current = true;
		}
	}, []);

	const recheckAuditImages = async () => {
		console.log("Rechecking audit images... Current status:", imageUploadStatus);
		
		if (!imageUploadStatus || Object.keys(imageUploadStatus).length === 0) {
			console.log("No image upload status available");
			return false;
		}

		for (let image_name_key in imageUploadStatus) {
			if (
				imageUploadStatus[image_name_key].s3_img_upload_status === 0 ||
				imageUploadStatus[image_name_key].sql_upload_status === 0
			) {
				console.log("Upload pending for:", image_name_key);
				return false;
			}
		}
		
		console.log("All images uploaded successfully. Proceeding...");
		await handleProceed();
		return true;
	};

// const handleProceed = async () => {
// 	try {
// 		console.log("handleProceed called for audit:", auditID);
		
// 		// Pehle database update karein
// 		console.log("Updating audit status in database...");
// 		const result2 = await axios.post("/create_audit/update_token", {
// 			audit: auditID,
// 			processed: 1,
// 			status: "processing"
// 		});
		
// 		console.log("Database update response:", result2.data);
// 		setQualityCheck(true);
		
// 	} catch (error) {
// 		console.error("Error in handleProceed:", error);
// 		setQualityCheck(true);
// 		toast.error('Database update failed, but continuing process', {
// 			position: "bottom-right",
// 			autoClose: 3000,
// 		});
// 	}
// };

const handleProceed = async () => {
	try {
		console.log("handleProceed called for audit:", auditID);

		const uploadedImages = [];

		for (let i = 0; i < localStorage.length; i++) {
			const key = localStorage.key(i);

			if (key.startsWith(`stencil_result_${auditID}`)) {
				try {
					const value = JSON.parse(localStorage.getItem(key));

					if (value?.result === "Retaken") {
						// const dbImageName = value.file_name.replace(/^[0-9A-Z]+_/, '');
						uploadedImages.push(value.file_name);
					}
				} catch (err) {
					console.error("Error parsing localStorage:", err);
				}
			}
		}

		for (const image_name of uploadedImages) {
			await axios.post("/create_audit/update_token", {
				audit: auditID,
				retake_status: "YES",
				image_name: image_name
			});

		}

		const result2 = await axios.post("/create_audit/update_token", {
			audit: auditID,
			processed: 1,
			status: "processing"
		});

		console.log("Database update response:", result2.data);

		setQualityCheck(true);

	} catch (error) {
		console.error("Error in handleProceed:", error);

		setQualityCheck(true);

		toast.error('Database update failed, but continuing process', {
			position: "bottom-right",
			autoClose: 3000,
		});
	}
}; 

	// Debug useEffect - har state change ko log karein
	useEffect(() => {
		console.log("=== STATE UPDATE ===");
		console.log("Quality Check:", qualityCheck);
		console.log("Report Generation:", reportGeneration);
		console.log("Report Generated:", reportGenerated);
		console.log("Email Sent:", emailSent);
		console.log("Rating Succeeded:", ratingSucceeded);
		console.log("====================");
	}, [qualityCheck, reportGeneration, reportGenerated, emailSent, ratingSucceeded]);

	return (
		<>
			<div className="success-container">
				<div className="illustration-section">
					<img src={success} alt="Success Illustration" />
				</div>
				<div className="content-section">
					<div className="check-icon">
						<img src={check} alt="Check Icon" />
					</div>
					{!qualityCheck &&(
						<>
							<h2>Processing</h2>
							<p>We are processing the inspection. Keep the window open.</p>
						</>
					)}
					{qualityCheck &&  !reportGenerated &&(
						<>
							<h2>Processing</h2>
							<p>We are processing the inspection. Keep the window open.</p>
						</>
					)}
					{/* {qualityCheck && !reportGenerated && (
						<>
							<h2>Quality Check Complete</h2>
							<p>Generating report... This may take a moment.</p>
						</>
					)}  */}
					{qualityCheck && reportGenerated && ratingSucceeded && (
						<>
							<h2>Processed</h2>
							<p>
								Inspection <strong>{auditID}</strong> is completed! You can close the window now
							</p>
						</>
					)}

					<ol className="steps-list">
						<li className="step">
							<span className="step-number-audit">
								<img src={step1_pink} alt="Step 1" />
							</span>
							Quality Check
							{!qualityCheck && (
								<span>
									<CircularProgress
										sx={{ color: "#ff0088", width: "20px !important", height: "20px !important" }}
									/>
								</span>
							)}
							{!qualityCheck && <span className="upload-status">Uploading</span>}
							{/* {qualityCheck && <span className="upload-status success">✓ Done</span>} */}
							<span className="vertical-line"></span>
						</li>
						<li className="step">
							<span className="step-number-audit">
								{qualityCheck ? (
									<img src={step2_pink} alt="Step 2" />
								) : (
									<img src={step2_grey} alt="Step 2" />
								)}
							</span>
							Report Generation
							{qualityCheck && reportGeneration && !reportGenerated && (
								<span>
									<CircularProgress
										sx={{ color: "#ff0088", width: "20px !important", height: "20px !important" }}
									/>
								</span>
							)}
							{qualityCheck && reportGeneration && !reportGenerated && <span className="upload-status">Processing</span>}
							{/* {reportGenerated && <span className="upload-status success">✓ Done</span>} */}
							<span className="vertical-line2"></span>
							<ToastContainer />
						</li>
						<li className="step disabled-step">
							<span className="step-number-audit">
								{reportGenerated ? (
									<img src={step3_grey} alt="Step 3" />
								) : (
									<img src={step3_grey} alt="Step 3" />
								)}
							</span>
							Report Submission
							{/* {reportGenerated && <span className="upload-status">Ready</span>} */}
						</li>
					</ol>
					{qualityCheck && reportGenerated && !ratingSucceeded && (
	<button
		style={{
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			gap: "0.2rem",
			border: "1.5px solid #FF0083",
			padding: "0rem 1rem",
			backgroundColor: "white",
			borderRadius: "3px",
			opacity: "0.9",
			width: "100%",
			marginTop: "20px"
		}}
		onClick={closeTab}
	>
		<span
			style={{
				fontSize: "0.9rem",
				fontFamily: "'Montserrat', sans-serif",
				color: "#FF0083",
				padding: "0.5rem",
				cursor: "pointer"
			}}
		>
			Close
		</span>
	</button>
)}
				</div>
				
				<button className="rate-experience-btn" onClick={handleButtonClick}>
					<img src={star} alt="Star Icon" /> RATE EXPERIENCE
				</button>
			</div>

			{isPopupOpen && !ratingSucceeded && (
				<div className="popup-overlay">
					<div className="popup-content">
						<div className="close-popup" onClick={handleClosePopup}><CloseIcon /></div>
						<div className="rating-heading"><h4>How was your experience?</h4></div>
						<p>Please share with us your feedback:</p>
						<div className="rating-stars">
							{[1, 2, 3, 4, 5].map(starIndex => (
								<img
									key={starIndex}
									src={starIndex <= rating ? starFilled : starEmpty}
									alt={`Star ${starIndex}`}
									className="star-icon"
									onClick={() => handleStarClick(starIndex)}
								/>
							))}
						</div>
						<button
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: "0.2rem",
								border: rating != 0 ? "1.5px solid #FF0083" : "1.5px solid #0000003D",
								padding: "0rem 1rem",
								backgroundColor: rating != 0 ? "#FF0083" : "#dcdcdc",
								color: rating != 0 ? "#ffffff" : "#0000003D",
								borderRadius: "3px",
								opacity: "0.9",
								width: "100%",
								marginTop: "0.5rem"
							}}
							disabled={rating != 0 ? false : true}
							onClick={handleSubmit}
						>
							<p
								style={{
									fontSize: "0.9rem",
									fontFamily: "'Montserrat', sans-serif",
									color: rating != 0 ? "#ffffff" : "#0000003D",
									padding: "0.5rem",
									cursor: "pointer"
								}}
							>
								{isSubmittingRating ? 'Submitting...' : 'Submit'}
							</p>
						</button>
					</div>
				</div>
			)}
			
			{isPopupOpen && ratingSucceeded && (
				<div className="popup-overlay">
					<div className="popup-content-after-rating">
						<div className="close-popup" onClick={handleClosePopup}><CloseIcon /></div>
						<div className="rating-heading-completion">
							<h4>Thank you for sharing your feedback</h4>
						</div>
						<p style={{ textAlign: "center" }}>Now You Can Close The Browser.</p>
					</div>
				</div>
			)}

			{/* Retake Images Modal */}
			{isRetakePopupOpen && (
				<div className='popup-overlay'>
					<div className='popup-content-retake'>
						<div className='popup-header'>
							<h3 className='retake-heading'>Retake Images...</h3>
							<button
								className='close-btn'
								onClick={handleCloseRetakePopup}
							>
								✕
							</button>
						</div>

						<div className='retake-list'>
							{retakeImages.length > 0 ? (
								<>
									<p className='retake-instruction'>Please retake the following images:</p>
									{retakeImages.map((item, idx) => (
										<div key={idx} className='retake-item'>
											<span>{item.part}</span>
											<button
												type='button'
												className='camera-btn'
												onClick={() => handleCameraClick(item)}
											>
												<img
													src={cameraIcon}
													alt='camera'
													width={22}
													height={22}
												/>
											</button>
										</div>
									))}
								</>
							) : (
								<p className='no-retake'>No images require retake 🎉</p>
							)}
						</div>

						<input
							type='file'
							accept='image/*'
							capture='environment'
							ref={fileInputRef}
							onChange={handleImageCapture}
							style={{ display: 'none' }}
						/>
					</div>
				</div>
			)}
		</>
	);
};

export default Processing;